import { v4 as uuid } from "uuid";

export const randomAddressList = [
  {
    _id: uuid(),
    street: "266,SKV Sarani",
    state: "Delhi",
    zipcode: 564785,
    country: "India",
    mobile: 1235645890,
  },
  {
    _id: uuid(),
    street: "455 Bangalore Road",
    state: "Karnataka",
    zipcode: 560035,
    country: "India",
    mobile: 1235785890,
  },
  {
    _id: uuid(),
    street: "78 Agripada",
    state: "Maharashtra",
    zipcode: 400011,
    country: "India",
    mobile: 1821645890,
  },
  {
    _id: uuid(),
    street: "Anna Nagar East S.O",
    state: "Tamilnadu",
    zipcode: 600102,
    country: "India",
    mobile: 1278945890,
  },
];
